import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  question: '¿Qué necesito para recibir una evaluación?',
  answer: 'Solo tu estado de cuenta (merchant statement) más reciente. Con eso podemos analizar tus tarifas actuales y determinar si podemos ofrecerte mejores condiciones.'
}, {
  question: '¿Tiene costo revisar mi estado de cuenta?',
  answer: 'No. La evaluación es completamente gratuita y sin compromiso. No hay ningún costo por revisar tu información.'
}, {
  question: '¿Qué pasa si no pueden mejorar mi situación?',
  answer: 'Te lo decimos honestamente. No te presionamos para cambiar si no podemos ofrecerte mejores condiciones. Nuestra reputación se basa en la transparencia.'
}, {
  question: '¿Ofrecen POS y terminales?',
  answer: 'Sí. Ofrecemos terminales modernas, sistemas POS completos y opciones de integración con tu software actual.'
}, {
  question: '¿Hay contratos largos?',
  answer: 'No. Trabajamos sin contratos a largo plazo. Creemos que debes quedarte con nosotros porque estás satisfecho, no porque estés atrapado.'
}, {
  question: '¿Atienden en español?',
  answer: 'Sí. Todo nuestro equipo habla español. Entendemos la importancia de comunicarnos en tu idioma y conocer tu cultura de negocios.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="bg-white py-16 md:py-24" data-id="element-9">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-10">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-11">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold text-navy mb-4" data-id="element-12">
            Preguntas Frecuentes
          </h2>
          <p className="text-lg text-gray-600" data-id="element-13">
            Respuestas a las dudas más comunes
          </p>
        </motion.div>

        <div className="space-y-4" data-id="element-14">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-15">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-4 flex justify-between items-center bg-white hover:bg-gray-50 transition-colors text-left" data-id="element-16">
                <span className="font-semibold text-navy pr-4" data-id="element-17">
                  {faq.question}
                </span>
                <motion.div animate={{
              rotate: openIndex === index ? 180 : 0
            }} transition={{
              duration: 0.3
            }} data-id="element-18">
                  <ChevronDown className="text-gold flex-shrink-0" size={20} data-id="element-19" />
                </motion.div>
              </button>
              <AnimatePresence data-id="element-20">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} className="overflow-hidden" data-id="element-21">
                    <div className="px-6 py-4 bg-lightGray text-gray-700" data-id="element-22">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}